import classNames from '@/utils/classNames';
import type { FCC } from 'react-fc';
import styles from './TextCenter.module.css';

/** A simple paragraph of centered text */
export const TextCenter: FCC = ({ className, children }) => (
    <p className={classNames(styles.textCenter, className)}>{children}</p>
);
